export default __webpack_public_path__ + "static/media/avatar_tapir2.cd7651d2.mp3";